import React from 'react';
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from 'assets/icons';
import moment from 'moment';

registerLocale('es', es)
setDefaultLocale('es')

const CustomInput = (props: any) => {
	return (
		<div className={`container-datepicker ${props.color ? props.color : ''}`}
			onClick={props.onClick}>
			<img src={props.calendarIcon || Calendar} alt="calendar" />
			<p className={!props.value && props._placeholder ? 'placeholder' : ''}>{props.value || props._placeholder}</p>
		</div>
	)
}

const range = (max?: string, min?: string) => {
	const baseMax = max ? moment(max) : moment();
	var currentYear = (max && getYear(max)) || parseInt(baseMax.add(10, 'years').format('YYYY'));
	var years = [];
	const baseMin = min ? moment(min) : moment(currentYear, 'YYYY').subtract(100, 'years');
	var startYear = (min && getYear(min)) || parseInt(baseMin.format('YYYY'));

	while (startYear <= currentYear) {
		years.push(startYear++);
	}
	return years.reverse();
}

const getYear = (date: any) => parseInt(moment(date).format('YYYY'));
const getMonth = (date: any) => parseInt(moment(date).format('M')) - 1;

const months = [
	"Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
	"Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const _DatePicker = (props: any) => {
	const years = range(props.maxDate, props.minDate);
	const selectedDate = props.value ? moment(props.value).toDate() : null;
	const customHeader = {
		renderCustomHeader: (headerProps: any) => (
			<div className="container-custom-header-datepicker" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px' }}>
				<button type="button" onClick={headerProps.decreaseMonth} disabled={headerProps.prevMonthButtonDisabled}>
					{"<"}
				</button>
				{props.showYearDropdown ? (
					<div className="dropdowns-container">
						<select
							value={getYear(headerProps.date)}
							onChange={({ target: { value } }) => headerProps.changeYear(parseInt(value))}
						>
							{years.map(option => (
								<option key={option} value={option}>{option}</option>
							))}
						</select>

						<select
							value={months[getMonth(headerProps.date)]}
							onChange={({ target: { value } }) => headerProps.changeMonth(months.indexOf(value))}
						>
							{months.map(option => (
								<option key={option} value={option}>{option}</option>
							))}
						</select>
					</div>
				) : (
					<span className="current-month-year">
						{months[getMonth(headerProps.date)]} {getYear(headerProps.date)}
					</span>
				)}

				<button type="button" onClick={headerProps.increaseMonth} disabled={headerProps.nextMonthButtonDisabled}>
					{">"}
				</button>
			</div>
		)
	};

	return (
		<div className="form-group">
			{props.label && <label className="label-datepicker">{props.label}</label>}
			<DatePicker
				{...customHeader} // Siempre aplicamos el header personalizado
				maxDate={props.maxDate ? moment(props.maxDate).toDate() : null}
				minDate={props.minDate ? moment(props.minDate).toDate() : null}
				selected={selectedDate} // Usamos la variable convertida a Date
				onChange={props.onChange}
				disabled={props.disabled}
				showTimeSelect={props.showTimeSelect}
				showTimeSelectOnly={props.showTimeSelectOnly}
				timeFormat={props.timeFormat}
				timeIntervals={props.timeIntervals}
				timeCaption={props.timeCaption}
				popperPlacement={props.popperPlacement}
				showMonthYearPicker={props.showMonthYearPicker}
				dateFormat={props.dateFormat || 'dd/MM/yyyy'}
				customInput={<CustomInput {...props} _placeholder={props.placeholder} />}
			/>
		</div>
	)
}

export default _DatePicker;